import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from "redux";
import ListView from "../common/ListView";
import {searchProductHistory, getProduct} from "./actions";
import DateTimeDisplay from "../common/DateTimeDisplay";
import {decodeParams} from "../utils/params";
import BackButton from "../common/BackButton";

class ProductHistoryPage extends Component {
  static propTypes = {
    /* state */
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    search: PropTypes.object.isRequired,
    product: PropTypes.object.isRequired,
    /* actions */
    searchProductHistory: PropTypes.func.isRequired,
    getProduct: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.productId !== this.props.match.params.productId) this._load();
  }

  _load() {
    const {productId} = decodeParams(this.props.match.params);
    this.props.getProduct({productId});
  }

  render() {
    const {
      product, history, searchProductHistory,
      search: {searching, pagination, filters, sorter, results, searchFilter},
      match: {params},
    } = this.props;
    const {productId} = decodeParams(params);
    const columns = [
      {
        title: 'Created At',
        dataIndex: 'createdAt',
        key: 'createdAt',
        sorter: true,
        render: (createdAt) => <DateTimeDisplay dateTime={createdAt}/>,
        width: 165,
      },
      {
        title: 'SKU',
        dataIndex: 'sku',
        key: 'sku',
        sorter: true,
        width: 150,
      },
      {
        title: 'Qty Variance',
        dataIndex: 'quantityVariance',
        key: 'quantityVariance',
        width: 120,
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
      },
    ];
    console.log(history);
    return (
      <ListView
        title={[
          <BackButton key="back" history={history} />,
          ` ${product.name || ''} History`
        ]}
        searchPlaceholder="Search sku and description"
        loading={searching}
        columns={columns}
        dataSourceProvider={(payload) => searchProductHistory({...payload, filters: {...payload.filters, productId}})}
        dataSource={results}
        pagination={pagination}
        filters={filters}
        sorter={sorter}
        searchFilter={searchFilter}
        rowKey="eventId"
      />
    );
  }
}

const mapStateToProps = state => ({
  product: state.product.product || {},
  search: state.product.productHistorySearch,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  searchProductHistory,
  getProduct,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(ProductHistoryPage);



// WEBPACK FOOTER //
// ./src/Product/ProductHistoryPage.js